import _ from 'lodash';
export const createAliasTransform = alias => (
	item,
	input = []
) => {
	return input.reduce((result, key) => {
		let value;
		_.find(
			_.flattenDeep([alias[key]], 1),
			key => {
				value = _.get(item, key);
				return value;
			}
		);
		result.push(value);
		return result;
	}, []);
};
